let popup = () => {

    let module = {},
        popup,
        body,
        bodyhtml,
        page,
        main,
        nearestPopup,
        closeBtn,
        attachEvents = () => {
            $('[data-popup-trigger]').on('click', function(ev){
                ev.preventDefault();
                var $this = $(this);
                var popupSelector = $this.attr('data-popup-trigger');
                var triggerEl = $(popupSelector);

                triggerEl.show();

                setTimeout(function() {
                  bodyhtml.toggleClass('overflow-hidden');
                  body.toggleClass('position-fixed');
                  //main.toggleClass('blured');

                  $this.toggleClass('active');
                  triggerEl.toggleClass('active');
                }, 50);
            });
        },
        init = () => {

          body = $('body');
          bodyhtml = $('html, body');
          main = $('main');

          attachEvents();

          /**
           * Hide Panel
           */
          closeBtn = $('.close-button, .close');
          closeBtn.on('click', function (e) {
            e.preventDefault();
            nearestPopup = $(this).closest('.popup-modal');
            bodyhtml.removeClass('overflow-hidden');
            body.removeClass('position-fixed');
            //main.removeClass('blured');
            nearestPopup.removeClass('active');

            setTimeout(function() {
              nearestPopup.hide('');
            }, 250);
          });

          /**
           * Show All Lanhuages
           */
          const btnAllLanguages = $('#btnAllLanguages');
          btnAllLanguages.on('click', function (e) {
            e.preventDefault();
            $('.initial-lang-list').hide();
            $('.primary-lang-list').show();
          });


        };

    module.init = init;

    return module;

};

export default popup();